import { useFormik } from 'formik';
import { useEffect } from 'react';
import { Pqr } from '../../../../../../shared/types/modules/pqr';

export const usePqrRegisterHistory = (pqr?: Pqr) => {
    const formik = useFormik({
        initialValues: {
            createdBy: '',
            updatedBy: '',
        },
        onSubmit: console.log,
    });

    useEffect(() => {
        const { createdBy, updatedBy, reception } = pqr || {};
        formik.setValues({
            createdBy: createdBy
                ? `(${createdBy.username}) ${createdBy.name} ${createdBy.surname}`
                : reception || '',
            updatedBy: updatedBy
                ? `(${updatedBy.username}) ${updatedBy.name} ${updatedBy.surname}`
                : reception || '',
        });
    }, [pqr]);

    return {
        formik,
    };
};
